/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StartOcppLogUploadTask
 */
export interface StartOcppLogUploadTask {
    /**
     *
     * @type {Array<string>}
     * @memberof StartOcppLogUploadTask
     */
    chargerIds?: Array<string>;
    /**
     *
     * @type {string}
     * @memberof StartOcppLogUploadTask
     */
    outputFormat?: string;
    /**
     *
     * @type {Date}
     * @memberof StartOcppLogUploadTask
     */
    startTime?: Date;
    /**
     *
     * @type {Date}
     * @memberof StartOcppLogUploadTask
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the StartOcppLogUploadTask interface.
 */
export function instanceOfStartOcppLogUploadTask(
    value: object,
): value is StartOcppLogUploadTask {
    return true;
}

export function StartOcppLogUploadTaskFromJSON(
    json: any,
): StartOcppLogUploadTask {
    return StartOcppLogUploadTaskFromJSONTyped(json, false);
}

export function StartOcppLogUploadTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): StartOcppLogUploadTask {
    if (json == null) {
        return json;
    }
    return {
        chargerIds: json["chargerIds"] == null ? undefined : json["chargerIds"],
        outputFormat:
            json["outputFormat"] == null ? undefined : json["outputFormat"],
        startTime:
            json["startTime"] == null ? undefined : new Date(json["startTime"]),
        endTime:
            json["endTime"] == null ? undefined : new Date(json["endTime"]),
    };
}

export function StartOcppLogUploadTaskToJSON(
    value?: StartOcppLogUploadTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        chargerIds: value["chargerIds"],
        outputFormat: value["outputFormat"],
        startTime:
            value["startTime"] == null
                ? undefined
                : value["startTime"].toISOString(),
        endTime:
            value["endTime"] == null
                ? undefined
                : value["endTime"].toISOString(),
    };
}
